import React, { Fragment } from "react";
import DeleteIcon from "@usas/ui-web/components/icons/DeleteIcon";
import EditIcon from "@usas/ui-web/components/icons/EditIcon";
import UploadIcon from "@usas/ui-web/components/icons/UploadIcon";
import DollarSignIcon from "@usas/ui-web/components/icons/DollarSignIcon";
import FileExclamationIcon from "@usas/ui-web/components/icons/FileExclamationIcon";
import ReportIcon from "@usas/ui-web/components/icons/ReportIcon";
import ViewDashboardIcon from '@usas/ui-web/components/icons/ViewDashboardIcon';

import SGColumnHeader from "@usas/ui-web/components/grids/SGColumnHeader";

import { formatDate } from "@usas/ui-web/utils/DateFunctions";
import Constants from "@usas/ui-web/utils/Constants";
import useSortableGrid from "@usas/ui-web/utils/UseSortableGrid";
import SGConstants from "@usas/ui-web/utils/SGConstants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGridRow = ({ 
  meet, 
  clubOrgUnitId, 
  onUploadClicked, 
  onMeetReconClicked, 
  onDeleteClicked, 
  onViewMeetAnnouncementReport, 
  onViewUploadResultsInvoice,
  onEdit, 
  onGoToCart, 
  USAS_ORG_UNIT_ID }) => (
  <tr>
    {/* <td><a onClick={(e) => onEdit(e, meet)}>{meet.meetName || ''}</a></td> */}
    <td>{meet.meetName || ''}</td>
    <td>{meet.orgUnitName}</td>
    <td>{`${formatDate(meet.startDate)} - ${formatDate(meet.endDate)}`}</td>
    <td>{meet.meetClassification}</td>
    <td>{meet.meetType}</td>
    <td>{meet.status}</td>
    <td style={{ whiteSpace: 'nowrap' }}>
      {clubOrgUnitId === meet.hostOrgUnitId && meet.status === Constants.WORKFLOW_STATUS_APPROVED ? (
        <Fragment>
          {onUploadClicked !== undefined && meet.isPastMeet === true && 
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onUploadClicked(meet)}>
              <UploadIcon />
            </button>
          }
          {onDeleteClicked !== undefined && meet.hasResults === false &&
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onDeleteClicked(meet)}>
              <DeleteIcon />
            </button>
          }
        </Fragment>
      ) :
        <Fragment>
          {meet.sanctionOrgUnitId === USAS_ORG_UNIT_ID &&
            <>
              { meet.hasCartItem === false && meet.hasResults === false &&
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={(e) => onEdit(e, meet)}>
                <EditIcon />
              </button>
              }
              {new Date(meet.startDate) <= new Date() && !meet.isUploadLocked && meet.status === 'Paid' &&
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onUploadClicked(meet)}>
                <UploadIcon />
              </button>
              }
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onMeetReconClicked(meet)}>
                <FileExclamationIcon toolTipText="Meet Recon" />
              </button>
              {
                meet.hasResults === true &&
                <button
                  className={global.IconButtonMargin}
                  type="button"
                  onClick={() => onViewUploadResultsInvoice(meet)}>
                  <ViewDashboardIcon toolTipText="View Meet Sanction Invoice Report" />
                </button>
              }
            </>
          }
          {(meet.hasCartItem === true || meet.hasMeetUploadCartItem === true) &&
            <>
              {meet.isLoggedInPersonPayor === true ?
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onGoToCart()}>
                <DollarSignIcon ToolTipText='Pay' Color='black' />
              </button> 
              :
              <button className={global.IconButtonMargin}><DollarSignIcon ToolTipText='Must be paid by designated payor' Color='gray' /></button>
              }
            </>
          }
          {meet.status === 'Paid' &&
          <>
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onViewMeetAnnouncementReport(meet)}>
              <ReportIcon toolTipText="Meet Announcement" />
            </button>
          </>
        }
        </Fragment>
      }
    </td>
  </tr>
);

const SmallGridRow = ({ 
  meet, 
  clubOrgUnitId, 
  onUploadClicked, 
  onDeleteClicked, 
  onEdit,
  onMeetReconClicked,
  onViewMeetAnnouncementReport,
  onViewUploadResultsInvoice,
  onGoToCart,
  USAS_ORG_UNIT_ID
}) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}><span className="hidden-xs">{meet.meetName}</span>&nbsp;
      {clubOrgUnitId === meet.hostOrgUnitId && meet.status === Constants.WORKFLOW_STATUS_APPROVED ? (
        <Fragment>
          {onUploadClicked !== undefined && meet.isPastMeet === true && 
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onUploadClicked(meet)}>
              <UploadIcon />
            </button>
          }
          {onDeleteClicked !== undefined && meet.hasResults === false &&
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onDeleteClicked(meet)}>
              <DeleteIcon />
            </button>
          }
        </Fragment>
      ) :
        <Fragment>
          {meet.sanctionOrgUnitId === USAS_ORG_UNIT_ID &&
            <>
              { meet.hasCartItem === false && meet.hasResults === false &&
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={(e) => onEdit(e, meet)}>
                <EditIcon />
              </button>
              }
              {new Date(meet.startDate) <= new Date() && !meet.isUploadLocked && meet.status === 'Paid' &&
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onUploadClicked(meet)}>
                <UploadIcon />
              </button>
              }
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onMeetReconClicked(meet)}>
                <FileExclamationIcon toolTipText="Meet Recon" />
              </button>
              {
                meet.hasResults === true &&
                <button
                  className={global.IconButtonMargin}
                  type="button"
                  onClick={() => onViewUploadResultsInvoice(meet)}>
                  <ViewDashboardIcon toolTipText="View Meet Sanction Invoice Report" />
                </button>
              }
            </>
          }
          {(meet.hasCartItem === true || meet.hasMeetUploadCartItem === true) &&
            <>
              {meet.isLoggedInPersonPayor === true ?
              <button
                className={global.IconButtonMargin}
                type="button"
                onClick={() => onGoToCart()}>
                <DollarSignIcon ToolTipText='Pay' Color='black' />
              </button> 
              :
              <button className={global.IconButtonMargin}><DollarSignIcon ToolTipText='Must be paid by designated payor' Color='gray' /></button>
              }
            </>
          }
          {meet.status === 'Paid' &&
          <>
            <button
              className={global.IconButtonMargin}
              type="button"
              onClick={() => onViewMeetAnnouncementReport(meet)}>
              <ReportIcon toolTipText="Meet Announcement" />
            </button>
          </>
        }
        </Fragment>
      }
      {/* {clubOrgUnitId === meet.hostOrgUnitId && meet.status === Constants.WORKFLOW_STATUS_APPROVED ? (
        <Fragment>
          {onDeleteClicked !== undefined && meet.hasResults === false &&
            <button
              className={global.IconButton}
              type="button"
              onClick={() => onDeleteClicked(meet)}>
              <DeleteIcon />
            </button>
          }
          {onUploadClicked !== undefined &&
            <button
              className={meet.hasResults === false ? global.IconButtonMobileMargin : global.IconButton}
              type="button"
              onClick={() => onUploadClicked(meet)}>
              <UploadIcon />
            </button>
          }
        </Fragment>
      ) : <Fragment />} */}
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className="row">
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>Meet Name</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>{meet.meetName}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Host Organization</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{meet.orgUnitName}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Dates</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{`${formatDate(meet.startDate)} - ${formatDate(meet.endDate)}`}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Classification</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{meet.meetClassification}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Type</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{meet.meetType}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Status</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{meet.status}</div>
      </div>
    </div>
  </div>
);

const LargeGrid = ({ 
  data, 
  isLoading, 
  clubOrgUnitId, 
  onUploadClicked, 
  onMeetReconClicked, 
  onDeleteClicked, 
  onViewMeetAnnouncementReport, 
  onViewUploadResultsInvoice,
  onEdit, 
  onGoToCart, 
  USAS_ORG_UNIT_ID }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Meet Name'} columnField={'meetName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Host Organization'} columnField={'orgUnitName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Dates'} columnField={'startDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Classification'} columnField={'meetClassification'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Type'} columnField={'meetType'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Status'} columnField={'status'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <th></th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="7">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((meet, i) =>
              <LargeGridRow
                key={i}
                meet={meet}
                clubOrgUnitId={clubOrgUnitId}
                onUploadClicked={onUploadClicked}
                onMeetReconClicked={onMeetReconClicked}
                onDeleteClicked={onDeleteClicked}
                onViewMeetAnnouncementReport={onViewMeetAnnouncementReport}
                onViewUploadResultsInvoice={onViewUploadResultsInvoice}
                onEdit={onEdit}
                onGoToCart={onGoToCart}
                USAS_ORG_UNIT_ID={USAS_ORG_UNIT_ID} />)
            : <tr><td colSpan="7">No Meets</td></tr>
        }
      </tbody>
    </table>
  );
};

const SmallGrid = ({ 
  data, 
  isLoading, 
  clubOrgUnitId, 
  onUploadClicked, 
  onDeleteClicked,
  onViewMeetAnnouncementReport, 
  onViewUploadResultsInvoice,
  onMeetReconClicked,
  onEdit,
  onGoToCart,
  USAS_ORG_UNIT_ID }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      )
      : data.length > 0
        ? data.map((meet, i) => <
          SmallGridRow 
            key={i} 
            meet={meet} 
            clubOrgUnitId={clubOrgUnitId} 
            onUploadClicked={onUploadClicked} 
            onDeleteClicked={onDeleteClicked} 
            onMeetReconClicked={onMeetReconClicked} 
            onViewMeetAnnouncementReport={onViewMeetAnnouncementReport} 
            onViewUploadResultsInvoice={onViewUploadResultsInvoice} 
            onEdit={onEdit} 
            USAS_ORG_UNIT_ID={USAS_ORG_UNIT_ID} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Meets</div>
            </div>
          </div>
        )
    }
  </div>
);

const ClubMeetsGridV3 = ({ 
  data, 
  isLoading, 
  clubOrgUnitId, 
  onUploadClicked, 
  onMeetReconClicked, 
  onDeleteClicked, 
  onViewMeetAnnouncementReport, 
  onViewUploadResultsInvoice,
  onEdit, 
  onGoToCart, 
  USAS_ORG_UNIT_ID }) => (
  <Fragment>
    <LargeGrid 
      data={data} 
      isLoading={isLoading} 
      clubOrgUnitId={clubOrgUnitId} 
      onUploadClicked={onUploadClicked} 
      onMeetReconClicked={onMeetReconClicked} 
      onDeleteClicked={onDeleteClicked}
      onViewMeetAnnouncementReport={onViewMeetAnnouncementReport} 
      onViewUploadResultsInvoice={onViewUploadResultsInvoice}
      onEdit={onEdit} 
      onGoToCart={onGoToCart} 
      USAS_ORG_UNIT_ID={USAS_ORG_UNIT_ID} />
    <SmallGrid 
      data={data} 
      isLoading={isLoading} 
      clubOrgUnitId={clubOrgUnitId} 
      onUploadClicked={onUploadClicked} 
      onMeetReconClicked={onMeetReconClicked} 
      onDeleteClicked={onDeleteClicked} 
      onViewMeetAnnouncementReport={onViewMeetAnnouncementReport} 
      onViewUploadResultsInvoice={onViewUploadResultsInvoice}
      onEdit={onEdit} 
      onGoToCart={onGoToCart}
      USAS_ORG_UNIT_ID={USAS_ORG_UNIT_ID} />
  </Fragment>
);

export default ClubMeetsGridV3;